import React from "react";
import { Card, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PartnerApi } from "../../../../../../../services/Api/Partner/partnerTypes";

interface Props {
	show: boolean;
	onHide: () => void;
	partners: PartnerApi[];
}

const DashboardOrganizationModal = ({ onHide, show, partners }: Props) => {
	const { t } = useTranslation();

	return (
		<Modal show={show} onHide={onHide} className="organization-applications-modal">
			<Modal.Header closeButton>
				<Modal.Title>{t("modules.dashboard.action.create_organization.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>{t("modules.dashboard.field.create_organization.title")}</p>
				<div className="row mb-2">
					{partners.map((partner) => {
						return (
							<div key={partner.id} className="col-6">
								<div className="card-hover card">
									<Card.Link
										className="stretched-link"
										as={Link}
										to={`/partnership/${partner.id}/organizations/new`}
									/>
									<div className="card-body">
										<div className="d-flex flex-wrap gap-2">
											<h5 className="mb-0">{partner.name}</h5>
											<span
												className={`badge ${partner.parent ? "bg-danger" : "bg-primary"}`}
												style={{
													fontSize: "12px",
													verticalAlign: "middle",
													textWrap: "wrap",
												}}
											>
												{partner.parent ? partner.parent.name : "GOPOS"}
											</span>
										</div>
									</div>
								</div>
							</div>
						);
					})}
				</div>
				<hr />
				<div className="row">
					<div className="col">
						<div className="card-hover card">
							<Card.Link className="stretched-link" as={Link} to={"/register"} />
							<div className="card-body">
								<h5>{t("modules.dashboard.field.default_register.title")}</h5>
							</div>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default DashboardOrganizationModal;
